import { render } from "./system_configure.html?vue&type=template&id=02125de2&external"
import script from "./system_configure.js?vue&type=script&lang=js&external"
export * from "./system_configure.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__